module.exports = __webpack_public_path__ + "img/logo_cree.16fb64fc.png";